module.exports = __webpack_public_path__ + "static/media/video21.de370f6a.jpg";